import { Row, Col } from 'antd';
import styled from 'styled-components';
import Link from 'next/link';
import parseCategoryUrl from 'lib/parseCategoryUrl';
import { merriweather } from 'styles/GlobalStyle';

const Breadcrumb = styled.span`
    font-family: ${merriweather.style.fontFamily};
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.22;
    letter-spacing: 0.36px;
    text-align: left;
    text-transform: uppercase;
    a {
        color: ${(props) => props.theme.colors.primary};
    }
`;

interface Path {
    seoSlug: string;
    title: string;
}

interface Props {
    paths: Path[];
    type: string;
    separator?: string;
}

const resolveHrefByType = (category: Path, type: string) => {
    switch (type) {
        case 'category':
            return parseCategoryUrl(category as Category);
    }
};

const Breadcrumbs = ({ paths, type, separator = '/' }: Props): JSX.Element => (
    <Row justify="start">
        <Col>
            {paths.map((path) => {
                const last = paths.indexOf(path) === paths.length - 1;
                const url = resolveHrefByType(path, type);
                return (
                    <Breadcrumb key={path.title}>
                        <Link href={url}>{path.title}</Link>
                        {!last && <span> {separator} </span>}
                    </Breadcrumb>
                );
            })}
        </Col>
    </Row>
);

export default Breadcrumbs;
